import http from '../utils/http.js'
const project = 'sci/'

const file = {
  signal(key) {
    const url = project + 'file/signal'
    return http.get(url, { key }).then(res => {
      return res
    })
  },

  domain() {
    const url = project + 'file/domain'
    return http.get(url).then(res => {
      return res
    })
  }
}
export default file
